import { render, staticRenderFns } from "./wxlz.vue?vue&type=template&id=533e5120&scoped=true&"
import script from "./wxlz.vue?vue&type=script&lang=js&"
export * from "./wxlz.vue?vue&type=script&lang=js&"
import style0 from "./wxlz.vue?vue&type=style&index=0&id=533e5120&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533e5120",
  null
  
)

export default component.exports